var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "bill-payment-apply-dialog",
      attrs: {
        title: _vm.$t("CargoMsg.Cargo_BindApprovalTemplate"),
        visible: _vm.visible,
        "close-on-click-modal": false,
        "append-to-body": "",
        "before-close": _vm.handleClose,
        width: "760px"
      }
    },
    [
      _c("div", [
        _c("h1", [_vm._v(_vm._s(_vm.workflowTitle))]),
        _c(
          "table",
          {
            staticClass: "details-table",
            attrs: { cellpadding: "0", cellspacing: "0" }
          },
          [
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ApprovalSerialNumber")))
              ]),
              _c("td", { staticClass: "values" }),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_StartDate")))
              ]),
              _c("td", { staticClass: "values" })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Applicant")))
              ]),
              _c("td", { staticClass: "values" }),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PaymentApplicationNo")))
              ]),
              _c("td", { staticClass: "values" })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))
              ]),
              _c("td", { staticClass: "values" }),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InitiateBranchCompany")))
              ]),
              _c("td", { staticClass: "values" })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DateOfApplication")))
              ]),
              _c("td", { staticClass: "values" }),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InitiateDepartment")))
              ]),
              _c("td", { staticClass: "values" })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PaymentPeriod")))
              ]),
              _c("td", { staticClass: "values" }),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PaymentMethod")))
              ]),
              _c("td", { staticClass: "values" })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Amount")))
              ]),
              _c("td", { staticClass: "values" }),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Currency")))
              ]),
              _c("td", { staticClass: "values" })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.ourDepositBank")))
              ]),
              _c("td", { staticClass: "values" }),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.ourBankAccount")))
              ]),
              _c("td", { staticClass: "values" })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remarks")))
              ]),
              _c("td", { staticClass: "values" })
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }